<template>
    <div class="layer contactUs">
            <div class="card">
                <button title="Close window" @click="closeTheWindowContact"><i class="fas fa-plus"></i></button>
                <h2> تواصلوا معنا </h2>
                <nav>
                    <a href="https://wa.me/218911183493"><i class="fab fa-whatsapp"></i></a>
                    <a href="https://t.me/tommy_vercitte"><i class="fab fa-telegram-plane"></i></a>
                </nav>
            </div>
        </div>
</template>

<script>
export default {
    methods: {
        closeTheWindowContact() {
            // alert(1);
            this.$emit("closeContact", false);
        }
    }
} 
</script>